module.exports = __webpack_public_path__ + "img/byr.05013365.png";